jQuery(function ($) {

    function ctaAnimation() {
        var ctaBox = $('.cta-box-animation'),
            ctaBoxOffset = $('.cta-box-animation').offset().top - $(window).height() + ctaBox.outerHeight();

        if ($(document).scrollTop() > ctaBoxOffset && !ctaBox.hasClass('cta-box-animation--start')) {
            ctaBox.addClass('cta-box-animation--start');
        }
    }

    if ($('.cta-box-animation').length > 0) {
        $(window).on('scroll load', ctaAnimation);
    }

});